/**
 * Detects Android TV / Smart TV Chrome browsers.
 * Used to disable GPU-heavy CSS effects that cause stutter on low-end TV hardware.
 */
export const isTV: boolean =
  typeof navigator !== 'undefined' &&
  /Android TV|SMART-TV|AFT|TV Browser|GoogleTV|CrKey/i.test(navigator.userAgent);
